import React from "react";
import styles from "./styles/MechatronicsCTA.module.css";
import Icon from "../Home/common/Icon";
import ctaBg from "../../../images/contact-cta.jpg";

export default function MechatronicsCTA() {
  return (
    <section className={styles.cta} style={{ backgroundImage: `url(${ctaBg})` }}>
      <div className={styles.overlay} />
      <div className={styles.container}>
        <p className={styles.text}>
          Our mechatronics division is one stop solution for all your factory automation
          requirements. We're ready to lead you into the future of factory automation.
        </p>
        <a href="/contact" className={styles.ctaBtn}>
          <span className={styles.ctaIcon} aria-hidden="true">
            <Icon.Phone />
          </span>
          <span>GET STARTED</span>
        </a>
        <div className={styles.divider} />
      </div>
    </section>
  );
}
